import * as Types from '@crimeos-frontend/crime-os/graphql';

import { gql } from '@apollo/client';
import { Crime_Os_UpdateFieldResponseFragmentDoc } from '@crimeos-frontend/crime-os/graphql-docs';
import * as Apollo from '@apollo/client';
export type UpdateRecordFieldResponseMutationVariables = Types.Exact<{
  params: Types.UpdateRecordFieldResponseParams;
}>;


export type UpdateRecordFieldResponseMutation = { __typename: 'Mutation', updateRecordFieldResponse: { __typename: 'ComplaintAccessDenied', message?: string | null, complaintId: number } | { __typename: 'ComplaintNotFound', message?: string | null, complaintId: number } | { __typename: 'EditAccessDenied', message?: string | null, fieldId: string } | { __typename: 'FieldDateRangeValidationFailed', message?: string | null, fieldId: string } | { __typename: 'FieldIsDeleted', message?: string | null, fieldId: string, systemFieldEnum?: Types.SystemFieldEnum | null } | { __typename: 'FieldNotFound', message?: string | null, fieldId: string } | { __typename: 'FieldRegexValidationFailed', message?: string | null, fieldId: string } | { __typename: 'FieldResponse', fieldId: string, fieldResponseId: string, systemFieldEnum?: Types.SystemFieldEnum | null, generatedFieldResponses: Array<{ __typename: 'GeneratedFieldResponse', fieldId: string, fieldResponseId: string, systemFieldEnum?: Types.SystemFieldEnum | null, response?: { __typename: 'BaseUser', userId: string, profilePicUrl?: string | null, email?: string | null, userName?: string | null } | { __typename: 'GQLDateTimeType', dateTime?: string | null } | { __typename: 'GQLDateType', dateValue?: string | null } | { __typename: 'GQLFloatType', floatValue?: number | null } | { __typename: 'GQLIntType', integerValue?: number | null } | { __typename: 'GQLListStringType', values: Array<string> } | { __typename: 'GQLStringType', stringValue?: string | null } | { __typename: 'GQLTimeType', timeValue?: string | null } | { __typename: 'LookupResponseType', lookupResponses: Array<{ __typename: 'LookupResponse', label: string, value: string }> } | { __typename: 'PhoneNumberResponse', dialCode: string, iso2CountryCode?: string | null, phoneNumber: string } | { __typename: 'Status', statusId: string, name: string, color?: Types.ColorEnum | null, order: number } | null }>, response?: { __typename: 'BaseUser', userId: string, profilePicUrl?: string | null, email?: string | null, userName?: string | null } | { __typename: 'GQLDateTimeType', dateTime?: string | null } | { __typename: 'GQLDateType', dateValue?: string | null } | { __typename: 'GQLFloatType', floatValue?: number | null } | { __typename: 'GQLIntType', integerValue?: number | null } | { __typename: 'GQLListStringType', values: Array<string> } | { __typename: 'GQLStringType', stringValue?: string | null } | { __typename: 'GQLTimeType', timeValue?: string | null } | { __typename: 'LookupResponseType', lookupResponses: Array<{ __typename: 'LookupResponse', label: string, value: string }> } | { __typename: 'PhoneNumberResponse', dialCode: string, iso2CountryCode?: string | null, phoneNumber: string } | { __typename: 'Status', statusId: string, name: string, color?: Types.ColorEnum | null, order: number } | null } | { __typename: 'FieldResponseIsRequired', message?: string | null, fieldId: string } | { __typename: 'FieldResponseRegexValidationFailed', message?: string | null, fieldId: string } | { __typename: 'FileFormatIsNotAllowed', message?: string | null, fieldId: string, selectedFormat?: string | null } | { __typename: 'FloatFieldResponseOutOfRange', message?: string | null, fieldId: string } | { __typename: 'IntegerFieldResponseOutOfRange', message?: string | null, fieldId: string } | { __typename: 'InvalidCheckboxFieldResponse', message?: string | null, fieldId: string } | { __typename: 'InvalidDateFieldResponseFormat', message?: string | null, fieldId: string } | { __typename: 'InvalidDateTimeFieldResponseFormat', message?: string | null, fieldId: string } | { __typename: 'InvalidDropdownFieldResponse', message?: string | null, fieldId: string } | { __typename: 'InvalidEmailFieldResponse', message?: string | null, fieldId: string } | { __typename: 'InvalidFieldsSelectorFieldResponse', message?: string | null, fieldId: string } | { __typename: 'InvalidFileUploaderFieldResponse', message?: string | null, fieldId: string } | { __typename: 'InvalidFloatFieldResponse', message?: string | null, fieldId: string } | { __typename: 'InvalidIntegerFieldResponse', message?: string | null, fieldId: string } | { __typename: 'InvalidLookupFieldResponse', message?: string | null, fieldId: string } | { __typename: 'InvalidMultiSelectFieldResponse', message?: string | null, fieldId: string } | { __typename: 'InvalidPhoneNumberFieldResponse', message?: string | null, fieldId: string } | { __typename: 'InvalidRadioGroupFieldResponse', message?: string | null, fieldId: string } | { __typename: 'InvalidTimeFieldResponseFormat', message?: string | null, fieldId: string } | { __typename: 'InvalidUrlFieldResponse', message?: string | null, fieldId: string } | { __typename: 'NeedFieldsWritePermission', message?: string | null, fieldIds: Array<string> } | { __typename: 'NeedFieldWritePermission', message?: string | null, fieldId: string } | { __typename: 'ParentFieldNotFilled', message?: string | null, fieldId: string, parentFieldId: string } | { __typename: 'PhoneNumberIsNotValid', message?: string | null, fieldId: string, countryCode: string, phoneNumber: string } | { __typename: 'RecordAccessDenied', message?: string | null, recordId: string } | { __typename: 'RecordNotFound', message?: string | null, recordId: string } | { __typename: 'RequiredFieldsNotFilled', message?: string | null, fieldIds: Array<string> } | { __typename: 'TemplateNotFound', message?: string | null, templateId: string } | { __typename: 'UniqueFieldResponseAlreadyExists', message?: string | null, fieldId: string } };


export const UpdateRecordFieldResponseDocument = gql`
    mutation UpdateRecordFieldResponse($params: UpdateRecordFieldResponseParams!) {
  updateRecordFieldResponse(params: $params) {
    ... on FieldResponse {
      ...Crime_Os_UpdateFieldResponse
    }
    ... on RecordNotFound {
      message
      recordId
    }
    ... on RecordAccessDenied {
      message
      recordId
    }
    ... on FieldNotFound {
      message
      fieldId
    }
    ... on FieldIsDeleted {
      message
      fieldId
      systemFieldEnum
    }
    ... on FieldResponseIsRequired {
      message
      fieldId
    }
    ... on FieldResponseRegexValidationFailed {
      message
      fieldId
    }
    ... on UniqueFieldResponseAlreadyExists {
      message
      fieldId
    }
    ... on InvalidIntegerFieldResponse {
      message
      fieldId
    }
    ... on IntegerFieldResponseOutOfRange {
      message
      fieldId
    }
    ... on InvalidEmailFieldResponse {
      message
      fieldId
    }
    ... on FileFormatIsNotAllowed {
      message
      fieldId
      selectedFormat
    }
    ... on InvalidFloatFieldResponse {
      message
      fieldId
    }
    ... on FloatFieldResponseOutOfRange {
      message
      fieldId
    }
    ... on InvalidTimeFieldResponseFormat {
      message
      fieldId
    }
    ... on InvalidDateFieldResponseFormat {
      message
      fieldId
    }
    ... on InvalidDateTimeFieldResponseFormat {
      message
      fieldId
    }
    ... on InvalidUrlFieldResponse {
      message
      fieldId
    }
    ... on InvalidDropdownFieldResponse {
      message
      fieldId
    }
    ... on InvalidMultiSelectFieldResponse {
      message
      fieldId
    }
    ... on InvalidCheckboxFieldResponse {
      message
      fieldId
    }
    ... on InvalidRadioGroupFieldResponse {
      message
      fieldId
    }
    ... on InvalidPhoneNumberFieldResponse {
      message
      fieldId
    }
    ... on InvalidLookupFieldResponse {
      message
      fieldId
    }
    ... on InvalidFileUploaderFieldResponse {
      message
      fieldId
    }
    ... on ParentFieldNotFilled {
      message
      fieldId
      parentFieldId
    }
    ... on InvalidFieldsSelectorFieldResponse {
      message
      fieldId
    }
    ... on RequiredFieldsNotFilled {
      message
      fieldIds
    }
    ... on NeedFieldsWritePermission {
      message
      fieldIds
    }
    ... on EditAccessDenied {
      message
      fieldId
    }
    ... on ComplaintNotFound {
      message
      complaintId
    }
    ... on ComplaintAccessDenied {
      message
      complaintId
    }
    ... on TemplateNotFound {
      message
      templateId
    }
    ... on NeedFieldWritePermission {
      message
      fieldId
    }
    ... on FieldDateRangeValidationFailed {
      message
      fieldId
    }
    ... on FieldRegexValidationFailed {
      message
      fieldId
    }
    ... on PhoneNumberIsNotValid {
      message
      fieldId
      countryCode
      phoneNumber
    }
  }
}
    ${Crime_Os_UpdateFieldResponseFragmentDoc}`;
export type UpdateRecordFieldResponseMutationFn = Apollo.MutationFunction<UpdateRecordFieldResponseMutation, UpdateRecordFieldResponseMutationVariables>;
export type UpdateRecordFieldResponseMutationResult = Apollo.MutationResult<UpdateRecordFieldResponseMutation>;
export type UpdateRecordFieldResponseMutationOptions = Apollo.BaseMutationOptions<UpdateRecordFieldResponseMutation, UpdateRecordFieldResponseMutationVariables>;